import HomeBanner from 'gatsby-theme-gaviscon/src/components/HomeBanner/HomeBanner';
import './HomeBannerOverride.scss';

export default HomeBanner;
